import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';
import {StoryIssues} from 'components';
export function IssueManager({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) {
  return <StoryIssues />;
}
